import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-718591f7"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "update-content"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "header-content"
}, [/*#__PURE__*/_createElementVNode("h5", {
  style: {
    "margin-top": "5px"
  }
}, "提示:"), /*#__PURE__*/_createElementVNode("p", null, " 1、您留存的手机号、电子邮箱等联系方式信息将成为本公司联系您的主要途径，可能用于产品净值、产品报告、财富顾问调整等重要紧急事项的通知，请您务必妥善、准确填写本人有效联系方式。 "), /*#__PURE__*/_createElementVNode("p", null, " 2、请确认为您本人操作，且保证提交信息准确无误，因此造成的任何问题或后果由您自行承担。 ")], -1));
const _hoisted_3 = {
  class: "input-content"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "email-label"
}, "电子邮箱：", -1));
const _hoisted_5 = {
  class: "footer-content"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_divider = _resolveComponent("van-divider");
  const _component_van_field = _resolveComponent("van-field");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_form = _resolveComponent("van-form");
  const _component_PageNavBackLayoutCpt = _resolveComponent("PageNavBackLayoutCpt");
  return _openBlock(), _createBlock(_component_PageNavBackLayoutCpt, null, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createVNode(_component_van_divider), _createVNode(_component_van_form, {
      onSubmit: $options.onSubmit
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createVNode(_component_van_field, {
        modelValue: $data.email,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.email = $event),
        required: "",
        name: "email",
        placeholder: "请填写邮箱",
        rules: [{
          required: true,
          message: '请填写邮箱'
        }]
      }, null, 8, ["modelValue"])]), _createVNode(_component_van_divider), _createElementVNode("div", _hoisted_5, [_createVNode(_component_van_button, {
        plain: "",
        loading: $data.btnLoading,
        type: "primary",
        "native-type": "submit"
      }, {
        default: _withCtx(() => [_createTextVNode("保存")]),
        _: 1
      }, 8, ["loading"])])]),
      _: 1
    }, 8, ["onSubmit"])])]),
    _: 1
  });
}